const MAX_CAUSE_DEPTH = 6;
const EXPECTED_AUTH_STATUSES = new Set([401, 403]);

/**
 * True when the value looks like an expected auth-related HTTP failure
 * (401 Unauthorized / session expiry, or 403 Forbidden / missing permission)
 * coming from wretch's WretchError or a similar shape. Walks Error.cause for
 * wrapped failures. Used by Sentry beforeSend to drop noise the UI already
 * surfaces to the user via toast.
 */
export function isExpectedAuthHttpError(error: unknown): boolean {
  let current: unknown = error;
  for (let i = 0; i < MAX_CAUSE_DEPTH && current != null; i += 1) {
    const status = (current as { status?: unknown }).status;
    if (typeof status === 'number' && EXPECTED_AUTH_STATUSES.has(status)) {
      return true;
    }
    const cause =
      current instanceof Error && 'cause' in current
        ? (current as Error & { cause?: unknown }).cause
        : undefined;
    current = cause;
  }
  return false;
}
